var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-4"},[_c('a',{on:{"click":_vm.insertDownload}},[_c('div',{staticClass:"download d-flex justify-content-center align-items-center flex-column"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/images/downloadIcons/" + _vm.format + ".svg","alt":""}}),_vm._v(" "),_c('h5',[_vm._v("Download")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48a42778","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownloadIcon.vue
// module id = null
// module chunks = 